/** Typography class names — defined in ui-components.css */
export const typography = {
  pageTitle: 'ui-typo-page-title',
  pageSubtitle: 'ui-typo-page-subtitle',
  sectionTitle: 'ui-typo-section-title',
  sectionDescription: 'ui-typo-section-description',
  fieldLabel: 'ui-typo-field-label',
  fieldHelper: 'ui-typo-field-helper',
  tableHeader: 'ui-typo-table-header',
  tableCell: 'ui-typo-table-cell',
  badge: 'ui-typo-badge',
  button: 'ui-typo-button',
} as const;
